<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems='contextMenuItems' :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
              :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
      <e-columns>
        <e-column field='eventId' :headerText='$t("Alarm.eventId")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='eventLevelDes' :headerText='$t("Alarm.eventLevel")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
        <e-column field='neType' :headerText='$t("Alarm.neType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentType' :headerText='$t("Alarm.equipmentType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='eventTypeDes' :headerText='$t("Alarm.eventType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :formatter='typeFormat'></e-column>
        <e-column field='neEventFDN' :headerText='$t("Alarm.neEventFDN")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='eventName' :headerText='$t("Alarm.eventDes")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='comment' :headerText='$t("Alarm.remark")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='brdTypeDes' :headerText='$t("Alarm.brdType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='cabinet' :headerText='$t("Alarm.cabinet")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='frame' :headerText='$t("Alarm.frame")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='slot' :headerText='$t("Alarm.slot")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='subSlot' :headerText='$t("Alarm.subSlot")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='cause' :headerText='$t("Alarm.cause")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='advise' :headerText='$t("Alarm.advise")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getEventLogTableData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='detailDialog' :element='detailDialogSetting.element' :styles='detailDialogSetting.styles'>
      <template v-slot:dialog-content>
        <EventDetail ref='detailContent'></EventDetail>
      </template>
    </CustomDialog>
    <CustomDialog ref='filterDialog' :element='filterDialogSetting.element' :styles='filterDialogSetting.styles'>
      <template v-slot:dialog-content>
        <EventLogFilter ref='filterContent'></EventLogFilter>
      </template>
    </CustomDialog>
    <iframe enctype='multipart/form-data' style='display: none;' name='downloadAction'></iframe>
    <form style='display: none;' target='downloadAction' id='downloadForm' action='/lte/ems/fm/event/exportData' method='post'>
      <input id='formDataConditions' name='conditions' v-model='formDataConditions' />
      <input name='columnsMapper' v-model='formDataColumnsMapper' />
      <input name='roleNe' v-model='formDataRoleNe' />
    </form>
  </div>
</template>
<script>
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import CustomDialog from '../../common/CustomDialog';
  import EventDetail from './EventDetail';
  import EventLogFilter from './EventLogFilter';
  import { EventBus } from '../../../plugins/eventBus';

  export default {
    name: 'eventLogTable',
    components: {
      CustomDialog,
      EventDetail,
      EventLogFilter
    },
    props: {
      roleNe: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        selectionOptions: { type: 'Multiple' },
        contextMenuItems: [{
          text: `${this.$t('Alarm.eventDetails')}`
        }],
        conditionsStatus: false,
        formDataConditions: '',
        formDataColumnsMapper: this.getColumnsMapper(),
        formDataRoleNe: this.roleNe.toString(),
        detailDialogSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.eventDetails'),
            target: '#app',
            refName: 'detail',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.close'), isPrimary: true } }
            ]
          }
        },
        filterDialogSetting: {
          styles: {
            width: '810px',
            height: 'auto',
            model: true,
            visible: false
          },
          element: {
            title: this.$t('Alarm.advancedSearchSetting'),
            refName: 'filter',
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
              { click: this.filterConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
            ]
          }
        },
        isOn: '0',
        page: {
          pageNo: 1,
          pageSize: 10,
          totalCount: 0,
          pageCount: 10
        },
        queryConditions: {
          systemId: '1',
          keywords: ''
        },
        data: [],
        topoList: []
      };
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    watch: {
      roleNe() {
        this.formDataRoleNe = this.roleNe.toString();
        this.getEventLogTableData();
      }
    },
    methods: {
      levelFormat(grids, data) {
        data.eventLevelDes = this.$t(`Alarm.alarmLevel_${data.eventLevel}`);
        return `<span class='h-alarmLevel${data.eventLevel}'>${this.$t(`Alarm.alarmLevel_${data.eventLevel}`)}</span>`;
      },
      typeFormat(grids, data) {
        let str = this.$t(`Alarm.alarmType_${data.eventType}`);
        data.eventTypeDes = str;
        return str;
      },
      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
          menuArgs.cancel = true;
        }
      },
      menuClickFunc(menuArgs) { // 为右键分配事件
        switch (menuArgs.element.innerText) {
          case `${this.$t('Alarm.eventDetails')}`:
            this.showDetail();
            break;
          default:
        }
      },
      dialogHide() {
        this.$refs.detailDialog.clear();
        this.$refs.detailDialog.close();
        this.$refs.filterDialog.clear();
        this.$refs.filterDialog.close();
      },
      getColumnsMapper() {
        return `eventId:${this.$t('Alarm.eventId')};`
          + `systemDes:${this.$t('Alarm.sysDescription')};`
          + `systemType:${this.$t('Alarm.sysType')};`
          + `eventLevelDes:${this.$t('Alarm.eventLevel')};`
          + `neType:${this.$t('Alarm.neType')};`
          + `neName:${this.$t('Alarm.neName')};`
          + `equipmentType:${this.$t('Alarm.equipmentType')};`
          + `equipmentName:${this.$t('Alarm.equipmentName')};`
          + `eventTypeDes:${this.$t('Alarm.eventType')};`
          + `neEventFDN:${this.$t('Alarm.neEventFDN')};`
          + `eventName:${this.$t('Alarm.eventDes')};`
          + `createTimeFormat:${this.$t('Alarm.createTime')};`
          + `comment:${this.$t('Alarm.remark')};`
          + `brdTypeDes:${this.$t('Alarm.brdType')};`
          + `cabinet:${this.$t('Alarm.cabinet')};`
          + `frame:${this.$t('Alarm.frame')};`
          + `slot:${this.$t('Alarm.slot')};`
          + `subSlot:${this.$t('Alarm.subSlot')};`
          + `cause:${this.$t('Alarm.cause')};`
          + `advise:${this.$t('Alarm.advise')};`
          + `xxdwinfo1:${this.$t('Alarm.xxdwinfo1')};`
          + `xxdwinfo2:${this.$t('Alarm.xxdwinfo2')};`
          + `xxkzinfo1:${this.$t('Alarm.xxkzinfo1')};`
          + `xxkzinfo2:${this.$t('Alarm.xxkzinfo2')};`
          + `xxkzinfo3:${this.$t('Alarm.xxkzinfo3')};`
          + `xxkzinfo4:${this.$t('Alarm.xxkzinfo4')};`;
      },
      getCheckedData(selectOnly) {
        // false: 不支持多选   true: 支持多选
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (selectedRecords.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
          return false;
        }
        if (selectedRecords.length > 1 && !selectOnly) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
          return false;
        }
        return selectedRecords;
      },
      getCheckedVals() {
        const messageNos = [];
        const checkedData = this.getCheckedData(true);
        for (let i = 0; i < checkedData.length; i++) {
          messageNos.push(checkedData[i].messageNo);
        }
        return messageNos;
      },
      getEventLogTableData() {
        // 获取表格数据
        const This = this;
        let conditionsStr = '';
        let keywordsStr = '';
        if (This.conditionsStatus === true) {
          conditionsStr = This.queryConditions.conditions;
        } else {
          keywordsStr = This.queryConditions.keywords;
        }
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        if (This.page.pageNo == 1) {
          This.$refs.pager.ej2Instances.currentPage = 1;
        }
        This.$axios.post('/lte/ems/fm/event/queryEvent', {
          page: {
            pageNo: This.page.pageNo,
            pageSize: This.page.pageSize
          },
          keywords: keywordsStr,
          conditions: conditionsStr,
          roleNe: This.roleNe
        }).then((response) => {
          if (response && response.status === 200) {
            const result = response.data.resultVal;
            This.page.totalCount = result.totalCount;
            This.data = result.result;
          }
        });
      },
      showDetail() {
        this.$refs.detailDialog.show();
        this.$refs.detailContent.setData(this.$refs.grid.getSelectedRecords()[0]);
      },
      exportEventLogData() {
        // 导出条件设置
        this.filterDialogSetting.element.title = this.$t('Alarm.exportSetting');
        this.$refs.filterDialog.show();
        // this.$refs.filterContent.clearCondition();
        this.$refs.filterContent.setTopoList(this.topoList);
        this.$refs.filterContent.setCondition(this.queryConditions.conditions);
      },
      filterFunc() {
        // 事件高级查询
        this.filterDialogSetting.element.title = this.$t('Alarm.advancedSearchSetting');
        this.$refs.filterDialog.show();
        // this.$refs.filterContent.clearCondition();
        this.$refs.filterContent.setTopoList(this.topoList);
        this.$refs.filterContent.setCondition(this.queryConditions.conditions);
      },
      filterConfirmFunc(clickEvent) {
        if (clickEvent.keyCode === 13) {
          return;
        }
        const exportConditions = this.$refs.filterContent.getCondition();
        if (exportConditions !== false) {
          if (this.filterDialogSetting.element.title === this.$t('Alarm.advancedSearchSetting')) {
            this.topoList = this.$refs.filterContent.getTopoList();
            this.queryConditions.conditions = exportConditions;
            this.dialogHide();
            this.conditionsStatus = true;
            this.getEventLogTableData();
          } else {
            this.formDataConditions = exportConditions;
            document.getElementById('formDataConditions').value = exportConditions;
            document.getElementById('downloadForm').submit();
            this.dialogHide();
          }
        }
      }
    }
  };
</script>
